/**
 * ProductAuditListContainer
 * --
 */
import React from 'react';
import ProductAuditListPresenter from './ProductAuditListPresenter';

const ProductAuditListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProductAuditListPresenter />
    </>
  );
};

export default ProductAuditListContainer;
